import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Breakpoints, BreakpointObserver } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { Router, NavigationStart, NavigationEnd, NavigationCancel, NavigationError } from '@angular/router';
import { IsLoadingService } from 'src/app/services/loading.service';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-fschflayout',
  templateUrl: './fschflayout.component.html',
  styleUrls: ['./fschflayout.component.scss']
})
export class FscHFLayoutComponent implements OnInit {
  title = 'Fsc Customer Portal';
  isLoading: Observable<boolean>;

  isSmallScreen = false;
  constructor(public router: Router, private isLoadingService: IsLoadingService,
    private breakpointObserver: BreakpointObserver) {
    breakpointObserver.observe([
      Breakpoints.XSmall,
      Breakpoints.Small,
      Breakpoints.Medium,
      Breakpoints.Large,
      Breakpoints.XLarge,
      Breakpoints.Handset,
      Breakpoints.Tablet,
      Breakpoints.Web,
      Breakpoints.HandsetPortrait,
      Breakpoints.TabletPortrait,
      Breakpoints.WebPortrait,
      Breakpoints.HandsetLandscape,
      Breakpoints.TabletLandscape,
      Breakpoints.WebLandscape
    ]).subscribe(result => {
      if (result.matches) {
        this.isSmallScreen = breakpointObserver.isMatched('(max-width: 599px)');
      }
    });
  }

  async ngOnInit() {
    this.isLoading = this.isLoadingService.isLoading$();
    await this.router.events
      .pipe(
        filter(
          event =>
            event instanceof NavigationStart ||
            event instanceof NavigationEnd ||
            event instanceof NavigationCancel ||
            event instanceof NavigationError,
        ),
      )
      .subscribe(event => {

        this.isLoadingService.remove();
        if (event instanceof NavigationStart) {
          this.isLoadingService.add();
          return;
        }
        this.isLoadingService.remove();
      });
  }

}
